/**
 * Default Input Props Object
 */
export const InputProps = {
  name: '',
  value: '',
  label: '',
  required: false,
  onChange: (e) => {}
}

/**
 * Input Label Props
 */
export const FieldLabelProps = {
  label: undefined,
  require: false,
  hasInput: false
}

/**
 * Input Banner Props
 */
export const FieldBannerProps = {
  icon: '',
  content: ''
}

export const InputPropsWithBanner = {
  ...InputProps,
  ...FieldBannerProps
}

export const FieldAvatarCheckboxProps = {
  ...InputProps,
  avatarUrl: ''
}

const InputOption = { label: '', value: '' }
export const InputOptionsProps = {
  ...InputProps,
  options: [InputOption]
}
